<script>
import { GlButton, GlTooltipDirective } from '@gitlab/ui';
import { s__ } from '~/locale';
import { AGENT_PLATFORM_CANCELABLE_STATUSES } from 'ee/ai/duo_agents_platform/constants';

export default {
  name: 'AgentSessionActions',
  components: {
    GlButton,
  },
  directives: {
    GlTooltip: GlTooltipDirective,
  },
  props: {
    status: {
      type: String,
      required: false,
      default: null,
    },
    canUpdateWorkflow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['cancel-session'],
  computed: {
    canCancelSession() {
      return AGENT_PLATFORM_CANCELABLE_STATUSES.includes(this.status);
    },
    cancelTooltip() {
      return this.canUpdateWorkflow
        ? s__('DuoAgentsPlatform|Cancel session')
        : s__('DuoAgentsPlatform|You do not have permission to cancel this session.');
    },
  },
};
</script>
<template>
  <span
    v-if="canCancelSession"
    v-gl-tooltip
    :title="cancelTooltip"
    data-testid="cancel-session-wrapper"
  >
    <gl-button
      icon="canceled-circle"
      size="small"
      :aria-label="s__('DuoAgentsPlatform|Cancel session')"
      :disabled="!canUpdateWorkflow"
      data-testid="cancel-session-icon-button"
      @click="$emit('cancel-session')"
    />
  </span>
</template>
